import React from "react";
import "./ProcessSection.scss";

const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      title: "Cuéntanos qué tipo de equipo necesitas",
      text: "Recibimos tu solicitud y entendemos qué tipo de maquinaria estás buscando para tu operación, producción o proyecto industrial.",
    },
    {
      number: "02",
      title: "Te mostramos opciones disponibles",
      text: "Con base en tu necesidad, te orientamos sobre los equipos que mejor se adaptan a tu requerimiento y tipo de trabajo.",
    },
    {
      number: "03",
      title: "Revisamos detalles del equipo",
      text: "Te compartimos información clave del equipo para que tengas mayor claridad antes de tomar una decisión.",
    },
    {
      number: "04",
      title: "Definimos entrega o recolección",
      text: "Coordinamos contigo si recogerás la maquinaria directamente con nosotros o si requiere envío a tu ubicación.",
    },
  ];

  return (
    <section className="process-section">
      <div className="container">
        <div className="process-section__heading">
          <div className="process-section__eyebrow">Proceso de atención</div>

          <h2 className="process-section__title">
            Un proceso claro para ayudarte a encontrar la maquinaria adecuada.
          </h2>

          <p className="process-section__subtitle">
            Nuestro objetivo es que cada cliente tenga una experiencia ordenada,
            confiable y enfocada en encontrar el equipo correcto para su operación.
          </p>
        </div>

        <div className="process-section__layout">
          <div className="process-section__timeline">
            {steps.map((step, index) => (
              <article className="process-section__step" key={index}>
                <div className="process-section__step-number">
                  <span>{step.number}</span>
                </div>

                <div className="process-section__step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="process-section__side">
            <div className="process-section__card">
              <span className="process-section__card-label">Compromiso</span>
              <h3>Te acompañamos para que tu inversión tenga más claridad</h3>
              <p>
                Más que solo mostrar maquinaria, buscamos que el proceso de
                atención te permita evaluar mejor tus opciones y avanzar con una
                decisión más segura para tu empresa o taller.
              </p>

              <a
                href={`https://wa.me/525515898591?text=${encodeURIComponent(
                  "Hola, me gustaría recibir más información sobre su maquinaria industrial."
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="header__cta"
              >
                Solicitar información
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;